import { gql, useQuery } from '@apollo/client';
import { captureException } from '@sentry/react';

// Shipper-scoped (carrier-less) PC Miler override. `order_mileage_enabled` is the live master
// switch that decides whether order mileage uses PC Miler instead of Google.
const PC_MILER_CONFIG = gql`
    query PcMilerConfig($shipper_id: uuid!) {
        overrides: integration_overrides(
            where: { type: { _eq: "PC_MILER" }, shipper_id: { _eq: $shipper_id }, carrier_id: { _is_null: true } }
            limit: 1
        ) {
            override_id
            config
        }
    }
`;

// Drives whether the web edit path routes distance() through the backend endpoint (PC Miler)
// vs the browser Google fast path. Based on the live toggle, not the order's pinned version.
export const usePcMilerConfig = (shipperId) => {
    const { data, loading, error, refetch } = useQuery(PC_MILER_CONFIG, {
        variables: { shipper_id: shipperId },
        skip: !shipperId,
        onError: (err) => {
            console.error(err);
            captureException(err);
        },
    });
    const config = data?.overrides?.[0]?.config || null;
    return { applies: !!config?.order_mileage_enabled, config, loading, error: error || null, refetch };
};
